import { render, staticRenderFns } from "./GiveRecordDetail.vue?vue&type=template&id=4bc1587c&scoped=true"
import script from "./GiveRecordDetail.vue?vue&type=script&lang=js"
export * from "./GiveRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./GiveRecordDetail.vue?vue&type=style&index=0&id=4bc1587c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc1587c",
  null
  
)

export default component.exports